<template>
    <div class="notificationsWrapper" v-click-outside="clickOutside">
       
       <!--Badge-->
       <a
            href="#0"
            class="notificationBtn icon hint hint--bottom"
            :class="{ active: showNotifications }"
            data-hint="Notifications"
            @click.prevent="toggleNotifications"
        >
            <ion-icon name="notifications"></ion-icon>
            <span v-if="itemsNew.length > 0" class="notificationsBadge">{{ itemsNew.length }}</span>
        </a>

        <!--Contents-->
        <div v-if="showNotifications" class="notificationsPopup sw">
            
            <h2>
                Notifications <template v-if="itemsNew.length > 0">({{ itemsNew.length }})</template>
                <a href="#0" @click.prevent="toggleNotifications" class="iconBtn closeBtn">
                    <ion-icon name="close"></ion-icon>
                </a>
            </h2>

            <div class="notificationsContent">

                <div class="notificationsList">

                    <div class="btns" v-if="itemsNew.length > 0">
                        <a 
                            @click.prevent="markAsRead()"
                            href="#0"
                            class="btn secondary icon-left markAllAsReadBtn"
                        >
                            <ion-icon name="eye"></ion-icon> Mark All as Read
                        </a>
                    </div>
                    
                    <p class="om-label">New <template v-if="itemsNew.length > 0">({{ itemsNew.length }})</template></p>

                    <ul v-if="itemsNew.length > 0">
                        <li v-for="item in itemsNew" :key="item.id">

                            <div class="item hasAvatar">
                                <div class="itemWrapper clearfix">
                                    <div class="col-11 float-left">
                                        <a href="#0" @click.prevent="goTo(item, true)" class="itemLink clearfix">
                                            <div class="col-2 float-left">
                                                <div class="avatar itemAvatar" :style="'background-image:url('+ $store.state.allUsers[item.uid].photoURL +');'"></div>
                                            </div>
                                            <div class="col-9 float-left">
                                                <p class="itemTitle">
                                                    {{ $store.state.allUsers[item.uid].displayName }}
                                                    
                                                    <template v-if="item.type === 'friendRequest'">
                                                        <span v-if="item.itemId === 'approved'">approved your friend request.</span>
                                                        <span v-else-if="item.itemId === 'sent'">sent you a friend request.</span>
                                                    </template>
                                                    <template v-else>
                                                        <span v-if="item.type === 'videos'">added a new video</span>
                                                        <span v-else-if="item.type === 'listing'">added a new listing</span>
                                                        <span v-else-if="item.type === 'chat'">sent you a new message</span>
                                                        {{ `"${item.message}"` }}.
                                                    </template>
                                                </p>
                                                
                                                <p class="itemDesc">{{ item.timestamp.toDate() | formatDate }}</p>
                                            </div>
                                        </a>
                                    </div>
                                    <div class="col-1 float-left">
                                        <div class="itemActions">
                                            <a 
                                                href="#0"
                                                class="iconBtn hint hint--left"
                                                data-hint="Mark as read"
                                                @click.prevent="markAsRead(item.id)"
                                            >
                                                <ion-icon name="close"></ion-icon>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </li>
                    </ul>
                    <p v-else class="empty">No new notifications.</p>

                    <p class="om-label">Earlier <template v-if="itemsOld.length > 0">({{ itemsOld.length }})</template></p>

                    <ul v-if="itemsOld.length > 0">
                        <li v-for="item in itemsOld" :key="item.id">

                            <div class="item hasAvatar old">
                                <div class="itemWrapper">
                                    <a href="#0" @click.prevent="goTo(item)" class="itemLink clearfix">
                                        <div class="col-2 float-left">
                                            <div class="avatar itemAvatar" :style="'background-image:url('+ $store.state.allUsers[item.uid].photoURL +');'"></div>
                                        </div>
                                        <div class="col-9 float-left">
                                            <p class="itemTitle">
                                                {{ $store.state.allUsers[item.uid].displayName }}
                                                
                                                <template v-if="item.type === 'friendRequest'">
                                                    <span v-if="item.itemId === 'approved'">approved your friend request.</span>
                                                    <span v-else-if="item.itemId === 'sent'">sent you a friend request.</span>
                                                </template>
                                                <template v-else>
                                                    <span v-if="item.type === 'videos'">added a new video</span>
                                                    <span v-else-if="item.type === 'listing'">added a new listing</span>
                                                    <span v-else-if="item.type === 'chat'">sent you a new message</span>
                                                    {{ `"${item.message}"` }}.
                                                </template>
                                            </p>

                                            <p class="itemDesc">{{ item.timestamp.toDate() | formatDate }}</p>
                                        </div>
                                    </a>
                                </div>
                            </div>

                        </li>
                    </ul>
                    <p v-else class="empty">No earlier notifications.</p>

                </div>

            </div>
        </div>
    </div>
</template>

<script>
const fb = require('@/firebaseConfig.js')
import moment from 'moment'

export default {
    data(){
        return{
            showNotifications: false,
            items: []
        }
    },

    async mounted(){
        if(this.$store.state.currentUser !== null){
            await this.$bind('items', this.$firebase.firestore().collection('users').doc(this.$store.state.currentUser.uid).collection('notifications').orderBy('timestamp', 'desc').limit(40))
        }
    },

    computed: {
        itemsNew(){
            return this.items.filter(item => {
                return item.seen === false
            })
        },
        itemsOld(){
            return this.items.filter(item => {
                return item.seen === true
            })
        }
    },

    methods: {
        // Notifications Logic
        async markAsRead(id){
            let userId = this.$store.state.currentUser.uid
            let allNewItems = this.itemsNew

            // Mark All as Read
            if(typeof id === 'undefined'){

                let batchProcess = []

                for(let i = 0; i < allNewItems.length; i++){
                    batchProcess.push(await this.updateNotificationSeen(allNewItems[i].id, userId))
                }

                Promise.all(batchProcess).then(results => {
                    
                    this.$notify({
                        group: 'globalNotifications',
                        title: `All (${batchProcess.length}) notifications marked as read.`
                    })
                    
                }).catch(err => {
                    console.log('Error marking all notifications: ', err)
                })

            // Mark Single as Read
            }else{
                await this.updateNotificationSeen(id, userId)

                this.$notify({
                    group: 'globalNotifications',
                    title: `Notification marked as read.`
                })
            }
        },
        async updateNotificationSeen(id, userId){
            
            let activityRef = fb.db.collection('users').doc(userId).collection('notifications').doc(id)
            let updates = {
                seen: true
            }

            await activityRef.set(updates, {merge: true}).then(() => {
                console.log('Successfully marked as seen!')
            })
        },
        goTo(item, mark){
            if(mark){
                this.markAsRead(item.id)
            }
            this.toggleNotifications()
            this.$router.push(item.path)
        },

        // Helpers
        toggleNotifications(){
            this.showNotifications = !this.showNotifications
        },
        clickOutside(){
            if(this.showNotifications){
                this.showNotifications = false
            }
        }
    },

    filters: {
        formatDate(value){

            let comDate = moment(value)
            let today = moment()
            let diff = today.diff(comDate, 'days')

            let formattedDate = ''
            
            if(diff === 0){
                formattedDate = comDate.format('h:mm a')
            }else if(diff > 1){
                formattedDate = diff + ' days ago'
            }else if(diff > 7){
                formattedDate = comDate.format('MMM DD - h:mm a')
            }
            
            return formattedDate 
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Notifications.vue